module.exports = __webpack_public_path__ + "static/LucasPope6-26f12fdf051806f1f6ab1b0b03d9b06c.webp";